import React from 'react';
import { useStore } from '../../stores';

export const Tags = () => {

  const { poi } = useStore();
    
  return (

    <div className="mb-4">
      {poi.active.categories.map((cat) => (
        <span className="bg-neutral-200 py-[2px] px-3 inline-block mr-2 mb-2 rounded" key={cat.name}>
          {cat.name}{' '}
        </span>
      ))}
    </div>

  );
  
};